var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'default': true, orange: _vm.orange, disabled: _vm.disabled, wide: _vm.wide, danger: _vm.danger, bigPadding: _vm.bigPadding },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cef11d6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../panel-theme/src/js/widgets/ds-button.vue
// module id = null
// module chunks = 